import { Component, OnInit } from '@angular/core';
import {
	FormControl,
	FormGroup
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';

import { User } from 'src/app/shared/models/security/user';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { ActivitePrestation } from 'src/app/shared/models/activitePrestation';
import { Prestation } from 'src/app/shared/models/prestation';
import { NotificationEmail, SendEmail } from 'src/app/shared/models/notificationEmail';
import { NotificationType, NotificationTypeEnum } from 'src/app/shared/enums/notification-type.enum';

@Component({
	selector: 'app-activitePrestation-modal-ajout',
	templateUrl: './activitePrestation-modal-ajout.component.html',
	styleUrls: ['./activitePrestation-modal-ajout.component.scss']
})
export class ActivitePrestationModalAjoutComponent implements OnInit {
	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };
	isAddressSelected: { value: boolean } = { value: false };

	LABEL_INTERVENANT: string;

	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp("^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+$");
	PHONE_NUMBER_PATTERN = '0{1}[0-9]{9}';

	formAjout: FormGroup = new FormGroup(
		{
			description: new FormControl(''),
			chargeTravail: new FormControl(''),
			tache: new FormControl(''),
			intervenant: new FormControl(''),
			modaliteReunion: new FormControl(''),
		}
	);

	prestation: Prestation = null;
	user: User;
	activitePrestation = new ActivitePrestation();
	notificationEmail : NotificationEmail;
	listNotificationType = NotificationType;
	sendMail = new SendEmail();

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private logger: LogService,
		private facade: FacadeService,
		public bsModalRef: BsModalRef
	) {}

	ngOnInit(): void {
		this.LABEL_INTERVENANT = this.facade.dataStorageService.getLabelCapitalized(
			PARAM_LABEL_INTERVENANT
		);
		this.user = this.facade.dataStorageService.getUser();
		if (this.user) {
			//this.center = this.user.activitePrestation.serviceCenter;
		}

		const prestationId = +this.router.url.split('/').pop();
		this.facade.prestationService
			.getPrestationById(prestationId)
			.subscribe((prestation: Prestation) => {
				this.prestation = prestation;
			});
	}

	onSubmit() {
		this.isValidateButtonClicked.value = true;
		this.activitePrestation.prestation = this.prestation;
		this.facade.activitePrestationService.addActivitePrestation(this.activitePrestation).subscribe({
			complete: () => {
				this.facade.notificationEmailService.getAllNotificationEmail().subscribe({
					next: (val) => {
						this.notificationEmail = val.find(x => x.type == this.listNotificationType.SUIVI_DELAI_MISSION)
						this.sendMail.email = this.activitePrestation.intervenant.email;
						this.sendMail.notificationEmail = this.notificationEmail;
						this.sendMail.prestation = this.prestation;
						this.facade.notificationEmailService.sendEmail(this.sendMail).subscribe({
							complete: () =>{
								this.bsModalRef.hide();
								this.isValidateButtonClicked.value = false;
							}
						})
					}
				})
			},
			error: (err: ErrorResponse) => {
				this.isValidateButtonClicked.value = false;
				this.facade.toastService.createHttpErrorToast(
					err.error.message,
					err.status
				);
			}
		});
	}
}

